export const formatEmailLogStats = (logCount, totalRecipients, addSingleQuote = false) => {
    if (logCount?.toString() && totalRecipients?.toString() && totalRecipients > 0) {
        return addSingleQuote ? `'${logCount}/${totalRecipients}'` : `${logCount}/${totalRecipients}`;
    }
    return "-"; 
};